export enum BankAccountType {
  Checkings = 0,
  Savings = 1,
}

export const bankAccountTypeList = [
  { label: "checkings", value: BankAccountType.Checkings },
  { label: "savings", value: BankAccountType.Savings },
];
